import React, { useState, useEffect, useRef } from "react";
import capitalintel from "../../assets/images/capital-intel-boston.png";
import image1 from "../../assets/images/capital-intel/1.png";
import image2 from "../../assets/images/capital-intel/2.png";
import image3 from "../../assets/images/capital-intel/3.png";
import image4 from "../../assets/images/capital-intel/4.png";
import image5 from "../../assets/images/capital-intel/5.png";
import image6 from "../../assets/images/capital-intel/6.png";
import image7 from "../../assets/images/capital-intel/7.png";
// import CapitalIntel from "./Company-profile";
import './capitalintel.css';
import CompanProfile from "./Company-profile";

const CapitalIntel = () => {
  const [activeSection, setActiveSection] = useState("introduction");
  const [searchTerm, setSearchTerm] = useState("");
  const sectionRefs = useRef({});
  const scrollTimeout = useRef(null);

  // Scroll to section
 const scrollToSection = (sectionId) => {
  // Clear any pending scroll timeout
  if (scrollTimeout.current) {
    clearTimeout(scrollTimeout.current);
  }
  setActiveSection(sectionId);

  const element = document.getElementById(sectionId);
  if (element) {
      element.scrollIntoView({ behavior: "smooth" });

    // Set a timeout to re-enable scroll detection after 1 second
    scrollTimeout.current = setTimeout(() => {
      scrollTimeout.current = null;
    }, 1000);
  }
};

  const assignRef = (id) => (el) => {
    if (el) {
      sectionRefs.current[id] = el;
    } else {
      delete sectionRefs.current[id];
    }
  };

  // Add scrollspy effect
  useEffect(() => {
    const contentEl = document.getElementById("company-profile-content");
    if (!contentEl) return;

    const handleScroll = () => {
      const sectionIds = [
        "introduction",
        "timeline",
        "rationale",
        "sectors",
        "global-impact",
        "scenarios",
        "markets",
        "legal",
        "case-study",
        "conclusion",
        "appendix",
      ];

      let currentSection = sectionIds[0];

      for (let id of sectionIds) {
        const ref = sectionRefs.current[id];
        if (ref) {
          const rect = ref.getBoundingClientRect();
          // Adjust threshold as needed
          if (rect.top <= 120) {
            currentSection = id;
          }
        }
      }
      setActiveSection(currentSection);
    };

    contentEl.addEventListener("scroll", handleScroll);

    return () => {
      contentEl.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
    <div className="container-fluid p-0" style={containerStyle}>
        <div
          className="banner-container"
          style={{
            height: "400px",
            background: `url(${capitalintel})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            marginBottom: "30px",
          }}
        ></div>

        <div className="row g-0 company-profile-row">
        {/* Sidebar */}
          <div className="col-md-3 company-profile-sidebar" style={sidebarStyle}>
          <div style={sidebarContentStyle}>
            <div style={navTitleStyle}>Report Navigation</div>
            <nav style={navStyle}>
              <ul style={navListStyle}>
                <li
                  style={
                    activeSection === "introduction"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("introduction")}
                >
                  Introduction
                </li>
                <li
                  style={
                    activeSection === "timeline"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("timeline")}
                >
                  Timeline
                </li>
                <li
                  style={
                    activeSection === "rationale"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("rationale")}
                >
                  Rationale
                </li>
                <li
                  style={
                    activeSection === "sectors"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("sectors")}
                >
                  Sector Analysis
                </li>
                <li
                  style={
                    activeSection === "global-impact"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("global-impact")}
                >
                  Global Impact
                </li>
                <li
                  style={
                    activeSection === "scenarios"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("scenarios")}
                >
                  Scenarios
                </li>
                <li
                  style={
                    activeSection === "markets"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("markets")}
                >
                  Financial Markets
                </li>
                <li
                  style={
                    activeSection === "legal"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("legal")}
                >
                  Legal Basis
                </li>
                <li
                  style={
                    activeSection === "case-study"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("case-study")}
                >
                  Case Study
                </li>
                <li
                  style={
                    activeSection === "conclusion"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("conclusion")}
                >
                  Conclusion
                </li>
                <li
                  style={
                    activeSection === "appendix"
                      ? activeNavItemStyle
                      : navItemStyle
                  }
                  onClick={() => scrollToSection("appendix")}
                >
                  Appendix
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Main Content */}
          <div
            className="col-md-9 company-profile-content"
            id="company-profile-content"
            style={contentStyle}
          >
          <div style={contentPaddingStyle}>
            {/* Introduction */}
              <section
                id="introduction"
                ref={assignRef("introduction")}
                style={sectionStyle}
              >
<h1 className="report-title">
  U.S. Liberation Tariff: Economic Realignment in Globalized World
</h1>
              <p style={authorStyle}>
                Authored by Yashaswini Ramesh, Syañrah Alhadar
                <br />
                Valuation Interns, Boston Financial Advisory Group (BFAG)
              </p>
              <p style={paragraphStyle}>
                It started with a signature. Within hours, wheat prices
                collapsed in the Midwest, semiconductor factories froze in
                Taiwan, and lithium shipments from Argentina were rerouted
                mid-ocean. On April 2, 2025, the United States imposed the
                  "Liberation Tariff"—a sweeping 10% tax on nearly every
                  imported product. What was framed as economic self-defence
                  quickly spiralled into a worldwide trade disruption, squeezing
                  farmers, rattling factories, and forcing diplomats into crisis
                  mode. Behind the bold rhetoric lay a deeper truth: the U.S.
                  faced mounting economic pressures, and tariffs were adopted as
                  both a tool to address these challenges and a signal of the
                administration's strategic priorities. As JPMorgan Chase CEO
                Jamie Dimon warned,{" "}
                <em>
                  "The U.S. economy remains at risk of recession due to
                  President Trump's ongoing tariff policies"
                </em>{" "}
                (The Times, 2025).
              </p>
            </section>

            {/* Timeline */}
              <section
                id="timeline"
                ref={assignRef("timeline")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                The Imposition of Tariffs: A Timeline of Economic Disruption
              </h2>
              <p style={paragraphStyle}>
                On April 2, 2025, US Current Administration invoked the
                  International Emergency Economic Powers Act (IEEPA) to
                  implement a blanket 10% "Liberation Tariff" on all U.S.
                  imports, impacting $3.1 trillion in trade to reduce foreign
                  reliance and bolster domestic manufacturing. Within a week,
                  targeted tariffs ranging from 11% to 50% were levied on 57
                  countries, with China facing rates up to 145% on electronics,
                  EVs, and semiconductors, affecting $400 billion in exports. In
                  retaliation, China imposed 125% tariffs on $110 billion of
                  U.S. goods and threatened rare earth restrictions. The U.S.
                  collected a record $16 billion in duties in April alone,
                  exceeding $70 billion by mid-year and contributing to a $258
                  billion budget surplus in Q2. Corporate impacts varied: tech
                  and retail firms saw rising costs and margin pressure,
                  automakers faced reduced exports, while domestic metal
                  producers benefited. A 90-day tariff reprieve in May
                  temporarily eased tensions, but underlying trade disputes
                remained unresolved.
              </p>
              <div style={figureContainerStyle}>
                  <img
                    src={image1}
                    alt="Tariff Timeline Visualization 1"
                    style={imageStyle}
                  />
              </div>
            </section>

            {/* Rationale */}
              <section
                id="rationale"
                ref={assignRef("rationale")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                Why the U.S. Imposed the Liberation Tariff?
              </h2>
              <p style={paragraphStyle}>
                The decision to impose the Liberation Tariff was rooted in a
                convergence of economic pressures and political strategy. By
                  early 2025, the United States was grappling with a national
                  debt that had swelled to $34 trillion—roughly 100% of its GDP.
                Interest payments alone were consuming over $700 billion
                annually, and projections by the Congressional Budget Office
                showed this figure would surpass $1.6 trillion by 2035 without
                intervention. The CBO also warned that without major fiscal
                reforms, the debt-to-GDP ratio could exceed 130% by 2040 and
                climb past 150% by 2055, signalling a long-term structural
                imbalance. At the same time, entitlement spending on programs
                like Medicare and Social Security was ballooning, expected to
                consume over half of federal expenditures by the 2030s. These
                  fiscal strains were compounded by a widening trade deficit and
                  a growing sense of vulnerability in global supply chains,
                especially following COVID-era disruptions. Against this
                backdrop, the administration turned to tariffs as both a
                revenue-generating mechanism and a tool for economic
                  nationalism. The Liberation Tariff was framed as a bold
                  attempt to reduce reliance on foreign goods, support domestic
                  manufacturing, and reassert America's control over its
                  economic destiny—all while sidestepping unpopular tax hikes or
                  spending cuts.
                </p>
              <div style={figureContainerStyle}>
                  <img
                    src={image2}
                    alt="Tariff Timeline Visualization 1"
                    style={imageStyle}
                  />
              </div>
            </section>

            {/* Sector Analysis */}
              <section
                id="sectors"
                ref={assignRef("sectors")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                Sectoral Fallout: Winners and Losers
              </h2>

              <h3 style={subsectionTitleStyle}>Losers</h3>
              <h4 style={sectorTitleStyle}>Consumer Electronics</h4>
              <p style={paragraphStyle}>
                  Companies such as Apple, Dell, and Nvidia were heavily
                  impacted due to their reliance on Chinese supply chains.
                  Tariffs led to a{" "}
                <strong>9–15% increase in the cost of goods sold</strong>,
                squeezing margins and prompting price hikes. Innovation
                timelines also slowed as companies scrambled to secure
                alternative component sources.
              </p>

              <h4 style={sectorTitleStyle}>Automotive</h4>
              <p style={paragraphStyle}>
                  The U.S. auto industry faced rising production costs,
                  averaging <strong>$2,000 more per vehicle</strong> due to
                  tariff-inflated input prices. Export volumes to markets like
                  China and Mexico fell by 11%, and major automakers like GM and
                  Ford were forced to cut their annual earnings forecasts.
              </p>

              <h4 style={sectorTitleStyle}>Retail</h4>
              <p style={paragraphStyle}>
                  Big-box retailers Walmart and Target saw their low-cost
                  sourcing strategies challenged. Hefty import duties forced
                  them to discount aggressively, resulting in margin
                  compressions of 1.8 and 1.3 percentage points, respectively.
                  This marked a notable setback in an already competitive retail
                  environment.
              </p>

              <h4 style={sectorTitleStyle}>Agriculture</h4>
              <p style={paragraphStyle}>
                No sector suffered more visibly than agriculture. China's
                retaliatory tariffs slashed U.S. exports of soybeans, corn,
                  pork, and wheat, devastating Midwestern farms. Federal
                  subsidies offered only temporary relief. Yet, despite these
                  hardships, 70% of U.S. farmers in an April 2025 Purdue
                  University survey expressed long-term optimism that tariffs
                  would ultimately strengthen the agricultural sector,
                  reflecting a disconnect between immediate losses and long-term
                  strategic hope.
              </p>

              <h3 style={subsectionTitleStyle}>Winners</h3>
              <h4 style={sectorTitleStyle}>Steel and Aluminium</h4>
              <p style={paragraphStyle}>
                  Domestic metal producers saw significant gains. Firms like
                  U.S. Steel and Alcoa benefited from reduced foreign
                  competition, with revenues rising 14–19%. Long-idle plants in
                  the Rust Belt were reactivated, bringing modest increases in
                  local manufacturing employment and economic activity.
              </p>
            </section>

            {/* Global Impact */}
              <section
                id="global-impact"
                ref={assignRef("global-impact")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                Global Repercussions and Strategic Realignment
              </h2>
              <p style={paragraphStyle}>
                The global response to the U.S. tariffs was swift and
                multifaceted. China's imposition of rare earth export controls
                rippled through supply chains critical to tech, defence, and
                green energy industries. In response, the European Union filed
                formal complaints with the World Trade Organization and began
                  reorienting trade policy to reduce reliance on both the U.S.
                  and China. Meanwhile, the United Kingdom leveraged the moment
                  to strike a bilateral deal with the U.S., securing tariff-free
                access for 100,000 vehicles annually in exchange for lowering
                ethanol duties and aligning aluminium standards. Even close
                  partners like Mexico and Canada, despite their participation
                  in the USMCA, were not exempt. Both countries faced 25%
                  tariffs unless they complied with strict U.S. content
                rules—demonstrating the leverage held by the vast American
                consumer market. This wave of realignment revealed a global
                  shift away from purely efficiency-driven globalization toward
                  a more resilience-oriented framework. Countries began
                  prioritizing diversified supply chains, regulatory autonomy,
                  and bilateral over multilateral trade partnerships.
              </p>
            </section>
            {/* Scenarios */}
              <section
                id="scenarios"
                ref={assignRef("scenarios")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                Scenario Analysis: Possible Futures
              </h2>
              <p style={paragraphStyle}>
                  Looking ahead, the trajectory of the U.S. Liberation Tariff
                  and its global repercussions can unfold along several possible
                scenarios.
              </p>

              <p style={paragraphStyle}>
                In the <strong>Best-case scenario</strong>, the United States
                successfully leverages the tariffs to accelerate domestic
                reindustrialization, leading to a gradual stabilization of
                global trade dynamics as countries adjust to new supply chain
                  realities. While consumer inflation would likely remain
                  elevated in the short term due to higher input costs, the
                  longer-term benefits could include strengthened domestic
                  manufacturing capacity and improved economic resilience.
              </p>

              <p style={paragraphStyle}>
                In the <strong>Base-case scenario</strong>, prolonged trade
                frictions persist, leading to a fragmented global economy
                characterized by supply chain disruptions, margin pressures
                  across industries, and persistent stagflation risks. Under
                  this scenario, commodity-exporting countries could benefit
                  from renewed focus on securing raw materials outside
                  traditional supply chains.
              </p>

              <p style={paragraphStyle}>
                In the <strong>Worst-case scenario</strong>, the tariff wars
                  spiral into a full-blown global recession, triggering
                  financial market turmoil, debt crises in emerging markets, and
                  large-scale capital flight to safe-haven assets such as the
                  Swiss franc, Japanese yen, and defence sectors. This scenario
                  would represent the most destabilizing outcome, undermining
                  global economic stability and eroding investor confidence
                  across developed and emerging economies alike.
              </p>
            </section>

            {/* Financial Markets */}
              <section
                id="markets"
                ref={assignRef("markets")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                Financial Markets & Investor Sentiment
              </h2>
              <p style={paragraphStyle}>
                Following the announcement of the U.S. Liberation Tariff on
                  April 2, 2025, global financial markets experienced a sharp
                  and immediate sell-off. Within two trading days, approximately
                  $6.6 trillion in market value was lost. The S&P 500 declined
                  by 4.9%, and other major indices across China, Germany,
                  France, Japan, and beyond followed with similarly steep drops.
                  This reaction was largely driven by short-term concerns around
                  increased input costs, potential supply chain disruptions,
                  inflation risks, and the possibility of retaliatory tariffs.
              </p>

              <p style={paragraphStyle}>
                Sectors such as electronics, automotive, and retail heavily
                dependent on global sourcing were hit the hardest, leading to
                broad sell-offs. Although the tariff was introduced to
                  strengthen long-term economic resilience, investors perceived
                  it as a near-term risk, with uncertainty overshadowing its
                  intended structural benefits.
              </p>

              <div style={figureContainerStyle}>
                  <img
                    src={image3}
                    alt="Tariff Timeline Visualization 1"
                    style={imageStyle}
                  />
              </div>

              <h3 style={subsectionTitleStyle}>
                Boston Financial Advisory Group's Perspective:
              </h3>
              <p style={paragraphStyle}>
                This initial market volatility should be seen as a temporary
                  adjustment rather than a sign of deeper weakness. The
                  Liberation Tariff represents a significant policy shift aimed
                  at rebuilding domestic capabilities, reducing external
                  dependencies, and encouraging industrial reinvestment. While
                  disruptions are expected in the short term, the long-term
                  outcome is likely to be more stable and resilient supply
                  chains, especially in sectors like rare earths element.
              </p>
            </section>

            {/* Legal Basis */}
              <section id="legal" ref={assignRef("legal")} style={sectionStyle}>
              <h2 style={sectionTitleStyle}>
                The Legal Foundation of The 2025 Liberation Tariff
              </h2>
              <p style={paragraphStyle}>
                  The 2025 liberation tariff marked a sweeping shift in U.S.
                  trade policy, rooted in three foundational statutes: Section
                  232, Section 301, and Section 201. Each section derives
                  authority from a different area of U.S. trade law and was
                  strategically used to advance the broader goal of reducing
                  foreign dependency and reviving domestic industry.
              </p>

              <h3 style={subsectionTitleStyle}>
                Section 232 – National Security Tariffs
              </h3>
              <h4 style={sectorTitleStyle}>Legal Basis:</h4>
              <p style={paragraphStyle}>
                Section 232 of the Trade Expansion Act of 1962 allows the
                President to impose tariffs on imports that threaten national
                security.
              </p>

              <h4 style={sectorTitleStyle}>Application in 2025:</h4>
              <p style={paragraphStyle}>
                Under this section, the U.S. levied tariffs on imports of
                critical materials such as steel, aluminium, and rare earth
                  elements, citing their importance to defense and key
                  industries. The administration argued that over-reliance on
                  foreign suppliers particularly from adversarial or unstable
                  regions left the U.S. vulnerable in times of geopolitical or
                  economic crises.
              </p>

              <h4 style={sectorTitleStyle}>Exemptions:</h4>
              <p style={paragraphStyle}>
                  To mitigate disruption among allied trading partners, Canada
                  and Mexico were granted exemptions for certain metal imports.
                  These exclusions were negotiated through diplomatic agreements
                  that included commitments to jointly monitor trade flows and
                  prevent transshipment of restricted materials through these
                  countries. The aim was to maintain supply chain stability
                  within North America while still addressing broader national
                  security concerns.
              </p>

              <h3 style={subsectionTitleStyle}>
                Section 301 – Unfair Trade Practices
              </h3>
              <h4 style={sectorTitleStyle}>Legal Basis:</h4>
              <p style={paragraphStyle}>
                Section 301 of the Trade Act of 1974 empowers the U.S. Trade
                Representative to take action against countries that engage in
                unfair trade practices, such as intellectual property theft,
                forced technology transfers, or market access restrictions.
              </p>

              <h4 style={sectorTitleStyle}>Application in 2025:</h4>
              <p style={paragraphStyle}>
                This section was used most aggressively, targeting over $400
                billion in Chinese imports with tariffs as high as 145%. The
                affected goods included semiconductors, consumer electronics,
                electric vehicles (EVs), and batteries, all of which are vital
                to modern industrial competitiveness and future technologies.
                These tariffs were intended to penalize China for persistent
                  violations of intellectual property rights and efforts to
                  coerce U.S. firms into sharing proprietary technologies.
              </p>

              <h4 style={sectorTitleStyle}>Exemptions:</h4>
              <p style={paragraphStyle}>
                Despite its breadth, Section 301 included a product exclusion
                process designed to shield U.S. businesses and consumers from
                excessive harm. Over $50 billion worth of products, including
                medical supplies, high-end electronics, and critical
                pharmaceutical ingredients, were eventually exempted following
                  petitions from U.S. industries. This ensured continued access
                  to essential imports without undermining the punitive intent
                  of the tariffs.
              </p>

              <h3 style={subsectionTitleStyle}>
                Section 201 – Import Safeguards
              </h3>
              <h4 style={sectorTitleStyle}>Legal Basis:</h4>
              <p style={paragraphStyle}>
                Section 201 of the Trade Act of 1974 allows the President to
                impose temporary restrictions on imports that are causing or
                threatening serious injury to a U.S. industry, regardless of
                whether the trade practices are deemed unfair.
              </p>

              <h4 style={sectorTitleStyle}>Application in 2025:</h4>
              <p style={paragraphStyle}>
                This section authorized a blanket 10% tariff on all U.S.
                imports, totalling around $3.1 trillion annually. Unlike
                Sections 232 and 301, Section 201 was applied broadly and
                  uniformly, framed as both an economic safeguard against
                  surging imports and a fiscal tool to address the national
                  debt, which had surpassed $34 trillion, or 100% of GDP. It
                  aimed to give domestic producers breathing room while
                  generating additional revenue.
              </p>

              <h4 style={sectorTitleStyle}>Exemptions:</h4>
              <p style={paragraphStyle}>
                Recognizing the need for nuanced application, Section 201 also
                included special carve-outs: A bilateral deal with the United
                  Kingdom allowed up to 100,000 British-made vehicles to enter
                  the U.S. tariff-free each year. These exceptions helped
                  cushion the economic impact on consumers and small enterprises
                  while maintaining the overarching protectionist structure.
                </p>
              </section>

              <section
                id="sector-analysis"
                ref={assignRef("sector-analysis")}
                style={sectionStyle}
              >
                <h2 style={sectionTitleStyle}>
                  The Most Promising and The Least Performing Sector After Trade
                  Disruptions
                </h2>
                <p style={paragraphStyle}>
                  This contrast highlights how tariff-driven trade policies are
                  not just reshaping bilateral trade flows but also redefining
                  the strategic landscape for global investment. Sectors aligned
                  with long-term geopolitical and environmental priorities, like
                  rare earth mineral are emerging as resilient opportunities,
                  while export-dependent, low-margin industries such as Chinese
                  EVs and electronics are facing structural headwinds. As
                  investors and policymakers navigate this evolving environment,
                  understanding these sectoral shifts becomes essential for
                  making informed, forward-looking decisions.
                </p>

                <h3 style={subsectionTitleStyle}>
                  The Most Promising Sector: Rare Earth Elements
                </h3>
                <p style={paragraphStyle}>
                  The rare earth elements sector, particularly outside of China,
                  stands to benefit in the post-tariff environment. Despite the
                  agreed 30% tariff on Chinese goods and 10% on U.S. goods,
                  China continues to threaten rare earth export restrictions,
                  critical materials used in EVs, defence, wind turbines, and
                  semiconductors.
                </p>
                <p style={paragraphStyle}>
                  In response, the U.S. and its allies are accelerating efforts
                  to secure alternative sources, especially in Australia,
                  Canada, and Latin America, making rare earths a clean energy
                  and national security priority.
                </p>
                <p style={paragraphStyle}>
                  Backed by government incentives and strategic investments,
                  rare earth mining and processing outside China is gaining
                  momentum. As supply chains realign to reduce reliance on
                  China, long-term demand is expected to grow. For investors,
                  this sector offers strong potential, supported by global
                  decarbonization goals and the rising need for battery and
                  high-tech materials.
                </p>

                <div style={figureContainerStyle}>
                  <img
                    src={image4} // Replace with your actual image import
                    alt="Global rare earth production market share"
                    style={imageStyle}
                  />
                  {/* <div style={figureCaptionStyle}>
      <em>Figure 4: Source: Boston Financial Advisory Group</em>
      <br />
      This chart illustrates China's continued dominance in global rare earth production, holding an estimated 60% market share in 2024. While countries
      like Australia (18%) and the U.S. (9%) have increased their output, China's control remains a central factor in supply chain risks. Growing shares from
      other regions reflect ongoing efforts to diversify sources amid rising geopolitical and tariff pressures.
    </div> */}
                </div>

                <h3 style={subsectionTitleStyle}>
                  The Least Promising Sector: Consumer Electronics
                </h3>
                <p style={paragraphStyle}>
                  The consumer electronics sector is struggling due to its heavy
                  dependence on international supply chains, which are
                  increasingly disrupted by tariffs and trade restrictions. With
                  key components like chips and batteries rising trade barriers
                  have led to production delays, cost increases, and logistical
                  challenges that hurt efficiency and profitability.
                </p>
                <p style={paragraphStyle}>
                  Because this industry runs on slim margins and serves a highly
                  price-sensitive market, it's especially vulnerable to cost
                  spikes from tariffs. Many manufacturers can't simply raise
                  prices without losing customers, making it harder to stay
                  competitive in major markets like the U.S. and Europe. Even
                  shifting production to other countries brings added expenses
                  and operational friction in the short term.
                </p>
                <p style={paragraphStyle}>
                  At the same time, global consumer demand is cooling. With
                  inflation and economic uncertainty on the rise, people are
                  spending less on non-essential electronics. This combination
                  of higher production costs and weaker consumer demand puts the
                  sector at a disadvantage, making it one of the least
                  attractive for investors in the current trade environment.
                </p>

                <div style={figureContainerStyle}>
                  <img
                    src={image5} // Replace with your actual image import
                    alt="Consumer electronics cost structure changes"
                    style={imageStyle}
                  />
                  {/* <div style={figureCaptionStyle}>
      <em>Figure 6: Source: Boston Financial Advisory Group</em>
      <br />
      This pie chart visualizes how tariffs are reshaping the cost structure of consumer electronics. Tariff-related costs now account for 15% of total expenses, eating into
      profit margins which have shrunk to just 10%. Previously negligible, tariffs are now a major line item, alongside raw materials, labour, and logistics highlighting how trade
      barriers are pressuring profitability and forcing companies to rethink their pricing and supply chain strategies.
    </div> */}
                </div>

                <h3 style={subsectionTitleStyle}>
                  Boston Financial Advisory Group's Perspective:
                </h3>
                <p style={paragraphStyle}>
                  "We maintain a cautiously optimistic stance. The rare earth
                  elements sector presents promising long-term opportunities,
                  supported by global efforts to enhance energy security and
                  reduce supply chain dependence. On the other hand, while the
                  consumer electronics sector faces notable challenges from
                  rising costs and shifting demand, we view this as a space
                  requiring careful monitoring rather than outright avoidance,
                  reflecting a neutral but risk- aware position".
              </p>
            </section>

            {/* Case Study */}
              <section
                id="case-study"
                ref={assignRef("case-study")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                A Case Study — The Rincon Lithium Project in Argentina
              </h2>
              <p style={paragraphStyle}>
                The ripple effects of American tariff policy reached as far as
                  the salt flats of Salta Province, Argentina — home to the
                  Rincon Lithium Project. Owned by an Australian mining firm,
                  this site was poised to become a key supplier of lithium to
                  Chinese battery manufacturers.
              </p>

              <p style={paragraphStyle}>
                Before the tariff war, lithium from Rincon travelled to China
                for processing, then to the U.S. for use in electric vehicles.
                  But after the 145% tariff on Chinese EVs and battery
                  components, the demand chain broke. Chinese firms reduced
                  orders from Rincon, citing uncertainty and high downstream
                  costs.
              </p>

              <p style={paragraphStyle}>
                  With the market destabilized, Rincon delayed Phase 2
                  expansion. Exploration teams were recalled, and new
                  infrastructure investments were paused. While some of the
                  lithium was redirected to South Korea and the EU, the loss of
                  the U.S.-China corridor illustrated how far-reaching and
                  unpredictable tariff policy could be.
              </p>

              <div style={figureContainerStyle}>
                  <img
                    src={image6}
                    alt="Tariff Timeline Visualization 1"
                    style={imageStyle}
                  />
              </div>
            </section>

            {/* Conclusion */}
              <section
                id="conclusion"
                ref={assignRef("conclusion")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>
                Conclusion: A Strategic Outlook on Tariffs from the U.S.
                Perspective
              </h2>
              <p style={paragraphStyle}>
                Despite the 2025 "Liberation Tariff" caused short-term
                disruptions and global pushback, it marked a major step in the
                  U.S. effort to strengthen its long-term economic position.
                  Faced with rising national debt, growing trade imbalances, and
                  fragile supply chains, the U.S. used tariffs not to shut
                  itself off from the world, but to reduce reliance on foreign
                  goods and encourage investment at home.
              </p>

              <p style={paragraphStyle}>
                Some industries, especially consumer electronics and, were hit
                hard at first. But the policy forced a broader rethink of how
                  goods move around the world, showing how much influence the
                  U.S. holds in trade. At the same time, American sectors like
                  steel and rare earths elements gained new life, boosting local
                production and jobs.
              </p>

              <p style={paragraphStyle}>
                Rather than focusing only on efficiency, this approach puts
                national strength and stability first. In today's uncertain
                global environment, it reflects a clear shift in priorities
                toward making sure the U.S. economy is more secure, more
                  flexible, and less vulnerable to outside shocks. The tariff
                  can be seen as a strategic reset aimed at building a more
                self-reliant and future ready American economy.
              </p>
            </section>

            {/* Appendix */}
              <section
                id="appendix"
                ref={assignRef("appendix")}
                style={sectionStyle}
              >
              <h2 style={sectionTitleStyle}>APPENDIX</h2>

              <h3 style={subsectionTitleStyle}>
                Appendix A: List of 57 Countries Facing Elevated U.S.
                Tariffs—Sectoral and Rate Details
              </h3>
              <div style={figureContainerStyle}>
                  <img
                    src={image7}
                    alt="Tariff Timeline Visualization 1"
                    style={imageStyle}
                  />
              </div>

              <h3 style={subsectionTitleStyle}>
                Appendix B: Tariff Targeting: How Limited-Sized Economies Are
                Hit Hardest by U.S. Trade Measures.
              </h3>
              <p style={paragraphStyle}>
                Countries with small geographic size and limited economic
                capacity—such as Lesotho, the Falkland Islands, Syria, and
                Vanuatu—are among those facing the highest U.S. tariffs, often
                ranging from 30% to 50%, despite having minimal trade volumes
                  and almost negligible trade deficits with the U.S. For
                  example, Lesotho, with a GDP of approximately $2.5 billion,
                  faces a 50% tariff even though its trade deficit with the U.S.
                  is only $0.23 billion. Similarly, Syria faces a 41% tariff on
                  its exports to the U.S., despite having just a $0.01 billion
                  trade deficit and an estimated GDP of $14 billion. These
                  examples reveal a consistent pattern: countries with minimal
                  economic leverage are often targeted with the highest tariffs.
              </p>

              <p style={paragraphStyle}>
                  The rationale behind this strategy is largely tactical.
                  Smaller nations have very limited capacity to retaliate
                  economically. Their exports to the U.S. are not critical to
                  American consumers or businesses, and their imports from the
                  U.S. are often negligible. For instance, Nauru, with a GDP of
                  only $0.1 billion, faces a 30% tariff even though there's
                  effectively no significant trade flow between it and the U.S.
                  This makes such countries "safe targets" for aggressive tariff
                  policies—allowing the U.S. administration to demonstrate
                  toughness on trade without risking a trade war or economic
                  fallout.
              </p>

              <p style={paragraphStyle}>
                Moreover, these high tariffs serve a symbolic purpose in
                reinforcing the U.S. administration's push for trade
                  reciprocity. In cases like Laos and Madagascar, which have
                  GDPs around $15–20 billion and trade deficits below $0.8
                  billion, the imposition of 47–48% tariffs send a signal that
                  even small-scale protectionism or trade imbalances will be met
                  with force. The political cost is low, the economic impact is
                  minimal, but the optics strongly support the administration's
                  "America First" trade narrative. Ultimately, these numbers
                  highlight how tariff policy can be more about leverage and
                  optics than strict economic logic.
              </p>

              <h3 style={subsectionTitleStyle}>
                  Appendix C: Economic Forecast Models and Trade Flow
                  Projections
              </h3>
              <p style={paragraphStyle}>
                Based on preliminary data modelling, the implementation of the
                U.S. Liberation Tariff is expected to exert upward pressure on
                inflation, with headline CPI projected to accelerate from 2.3%
                in Q1 2025 to 3.8% by Q3 2025, assuming tariff pass-through
                rates of 70% across consumer goods. Sector-specific EPS
                  (Earnings Per Share) forecasts have been revised downward,
                  with retail and consumer electronics sectors expected to face
                  EPS downgrades of 12% and 15%, respectively, driven by higher
                  input costs, margin erosion, and reduced consumer spending
                  power. The automotive sector is projected to see an 8% EPS
                  cut, factoring in both higher steel and aluminium costs and
                  reduced export volumes. Global trade flow projections indicate
                  a 3.5% contraction in U.S. merchandise imports and a 4.2%
                  decline in exports by year-end, as retaliatory tariffs and
                  supply chain disruptions dampen cross-border trade activity.
                  Emerging markets heavily reliant on U.S. consumer demand, such
                  as Vietnam and Mexico, are forecasted to experience GDP growth
                  downgrades of 1.2% and 0.9%, respectively, while commodity
                  exporters are expected to face price pressures across key raw
                  materials. These projections assume no further escalation; any
                  prolongation of trade hostilities could deepen the downturn
                  and amplify global financial vulnerabilities.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>

      <CompanProfile />
    </>
  );
};

// Styles
const containerStyle = {
  // height: "100vh",
  overflow: "hidden",
  marginTop: "0px",
};

const sidebarStyle = {
  backgroundColor: "#f8f9fa",
  height: "100vh",
  overflowY: "auto",
  position: "sticky",
  top: 0,
  borderRight: "1px solid #dee2e6",
};

const sidebarContentStyle = {
  padding: "20px",
};

  const navItemStyle = {
  padding: "8px 12px",
  cursor: "pointer",
  color: "#495057",
  transition: "all 0.2s ease",
  borderBottom: "1px solid #e9ecef",
  borderRadius: "4px",
  margin: "2px 0",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
  color: "white",
  backgroundColor: "#4d7b53",
  fontWeight: "600",
  };

const navTitleStyle = {
  fontSize: "14px",
  fontWeight: "600",
  color: "#4d7b53",
  margin: "20px 0 10px 0",
  textTransform: "uppercase",
  };

// Rest of the styles remain the same
const navStyle = {
  marginBottom: "30px",
};

const navListStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0,
};

const contentStyle = {
  height: "100vh",
  overflowY: "auto",
  backgroundColor: "#ffffff",
};

const contentPaddingStyle = {
  padding: "40px",
};

const sectionStyle = {
  marginBottom: "50px",
};

const titleStyle = {
  fontSize: "28px",
  fontWeight: "bold",
  marginBottom: "20px",
  color: "#333",
};

const sectionTitleStyle = {
  fontSize: "24px",
  fontWeight: "600",
  margin: "40px 0 20px 0",
  color: "#333",
  paddingBottom: "10px",
  borderBottom: "1px solid #dee2e6",
};

const subsectionTitleStyle = {
  fontSize: "20px",
  fontWeight: "600",
  margin: "30px 0 15px 0",
  color: "#333",
};

const sectorTitleStyle = {
  fontSize: "18px",
  fontWeight: "600",
  margin: "20px 0 10px 0",
  color: "#333",
};

const authorStyle = {
  fontSize: "14px",
  color: "#6c757d",
  fontStyle: "italic",
  marginBottom: "20px",
};

const paragraphStyle = {
  fontSize: "16px",
  lineHeight: "1.6",
  marginBottom: "20px",
  color: "#495057",
};

const figureContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "20px",
};

const imageStyle = {
  maxWidth: "100%",
  height: "auto",
  borderRadius: "4px",
};

const figureTitleStyle = {
  fontSize: "16px",
  fontWeight: "600",
  marginBottom: "10px",
  color: "#333",
};

const placeholderBoxStyle = {
  height: "200px",
  backgroundColor: "#e9ecef",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: "10px",
  color: "#6c757d",
  borderRadius: "4px",
};

const figureCaptionStyle = {
  fontSize: "14px",
  color: "#6c757d",
  fontStyle: "italic",
  lineHeight: "1.5",
};

export default CapitalIntel;
